import React, {Component} from "react";
import "./App.css";
import Home from "./Home";
import {BrowserRouter as Router, Route} from "react-router-dom";

class App extends Component {
    render() {
        return (
            <Router basename="/JTo5pR1B">
                <div>
                    <Route path="/" exact component={Home}/>
                </div>
            </Router>
        );
    }
}

export default App;